import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

const API_BASE = process.env.REACT_APP_API_BASE;

export default function CheckEmailPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const email = params.get('email');
  const token = params.get('token');

  const [isVerified, setIsVerified] = useState(false);
  const [loading, setLoading] = useState(!!token);

  useEffect(() => {
    const verifyToken = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/auth/verify-email?token=${token}`);
        const data = await res.json();
        if (res.ok) {
          setIsVerified(true);
          toast.success(data.message);
          setTimeout(() => navigate(`/login`), 2000); // Redirect to login
        } else {
          toast.error(data.message);
        }
      } catch (err) {
        toast.error('Verification failed');
      } finally {
        setLoading(false);
      }
    };

    if (token) verifyToken();
  }, [token, navigate]);

  const handleResend = async () => {
    if (!email) return toast.error('Missing email');

    const res = await fetch(`${API_BASE}/api/auth/resend-verification`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    });

    const data = await res.json();
    if (res.ok) toast.success(data.message);
    else toast.error(data.message);
  };

  return (
    <div className="min-h-screen flex flex-col justify-center items-center px-4 bg-gray-50">
      <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-6">
        <div className="flex justify-center mb-4">
          <img
            src="https://framerusercontent.com/images/0OxSHhWPheJQRCkT3wfqFZVf6mk.png?scale-down-to=512"
            alt="Ennoverse Logo"
            className="h-12"
          />
        </div>

        {loading ? (
          <p className="text-center text-gray-600">Verifying your email...</p>
        ) : isVerified ? (
          <>
            <h2 className="text-2xl font-semibold text-center text-gray-800 mb-4">
              Email Verified Successfully!
            </h2>
            <p className="text-center text-gray-600 mb-6">
            Let's get your account set up... <a href="/login">Click Here</a> if you are not redirected to login page within 10 seconds.
            </p>
          </>
        ) : (
          <>
            <h2 className="text-2xl font-semibold text-center text-gray-800 mb-4">
              Verify Your Email
            </h2>
            <p className="text-gray-600 text-center mb-4">
              A verification email has been sent to <strong>{email}</strong>. Please check your inbox and click the link to activate your account.
            </p>
            <p className="text-sm text-gray-500 text-center mb-6">
              Didn't get it? You can resend the email below.
            </p>
            <div className="flex justify-center">
              <button
                onClick={handleResend}
                className="bg-blue-600 hover:bg-blue-700 text-white px-5 py-2 rounded"
              >
                Resend Verification Email
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
